import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import styled from "@emotion/styled";
import { useSelector } from 'react-redux';

const PrivacySelect = styled(FormControl)(({ theme }) => ({
    minWidth: 120,
    marginTop: theme.spacing(1),
}));

const PrivacyDropdown = ({ value, onChange, floor = 'Public' }) => {
    const userPermissions = useSelector(state => state.auth.permissions);
    const canSeePrivate = userPermissions.includes('canSeePrivate');
    const canSeeInternal = userPermissions.includes('canSeeInternal');

    if (!canSeePrivate && !canSeeInternal) {
        return <span></span>; // Return null instead of an empty fragment
    }

    return (
        <PrivacySelect size="small">
            <InputLabel id="privacy-select-label">Privacy</InputLabel>
            <Select
                labelId="privacy-select-label"
                value={value}
                onChange={onChange}
                label="Privacy"
            >
                {floor === 'Public' && <MenuItem value="Public">Public</MenuItem>}
                {(canSeeInternal || canSeePrivate) && floor !== 'Private' && <MenuItem value="Internal">Internal</MenuItem>}
                {canSeePrivate && <MenuItem value="Private">Private</MenuItem>}
            </Select>
        </PrivacySelect>
    );
};

export default PrivacyDropdown;